import dayjs from "dayjs";
import customParseFormatPlugin from "dayjs/plugin/customParseFormat";
import dayOfYearPlugin from "dayjs/plugin/dayOfYear";
import durationPlugin from "dayjs/plugin/duration";
import dayjsMinMaxPlugin from "dayjs/plugin/minMax";
import relativeTimePlugin from "dayjs/plugin/relativeTime";

export function setupDayjs() {
  // Need this in order to parse dates from YYYY-MM-DD format.
  dayjs.extend(customParseFormatPlugin);
  dayjs.extend(durationPlugin);
  dayjs.extend(relativeTimePlugin);

  dayjs.extend(dayOfYearPlugin);
  dayjs.extend(dayjsMinMaxPlugin);
}

setupDayjs();

export * from "./accessor";
export * from "./duration";
export * from "./format";
export * from "./parse";
